/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { AxiosError, AxiosInstance } from 'axios';

import { baseUrl, NotaryAPI } from './types';

export const usersClient = (request: AxiosInstance) => ({
  async fetchCurrentUser(): Promise<NotaryAPI.UserResponse> {
    return (await request.get(`${baseUrl}/users`)).data;
  },

  async getUserById(id: string): Promise<NotaryAPI.UserResponse> {
    return (await request.get(`${baseUrl}/admin/users/${id}`)).data;
  },

  async checkProfileStatus(userId: string): Promise<NotaryAPI.UserStatusResponse> {
    return (await request.get(`${baseUrl}/users/${userId}/status`)).data;
  },

  async searchApprovedUser(searchText: string): Promise<NotaryAPI.GetUserListResponse> {
    try {
      const response = await request.get(`${baseUrl}/admin/users/search`, {
        params: { search: searchText, status: 'ACTIVE', limit: 5, offset: 0 },
      });
      return response.data;
    } catch (error) {
      if ((error as AxiosError)?.response?.status === 400) {
        // when query is deemed to be bad input, renders as no result
        return {
          users: [],
          totalCount: 0,
        };
      } else {
        throw error;
      }
    }
  },
});
